WiseMetering.Views.Zone = WiseMetering.Views.Content.extend({
    initialize({ model, view }) {
        this.icon = model.icon();
        this.tabs = [];

        this.tabs.push({
            active: view === 'details',
            href: `/${this.objectName()}/${model.id}/details`,
            id: 'details',
            name: i18next.t('common.details'),
            view: WiseMetering.Views.ZoneDetailsTab
        });

        if (model.isSite() && model.get('state') === 'active') {
            this.tabs.push({
                active: view === 'dashboard',
                href: `/zones/${model.id}/dashboard`,
                id: 'dashboard',
                name: i18next.t('common.dashboard'),
                view: WiseMetering.Views.ZoneDashboard
            });
        }

        if (model.type() === 'site') {
            const
                hasPermissions = WiseMetering.Permissions.hasPlanPermissions('opportunities'),
                viewName = hasPermissions ? 'IndexOpportunity' : 'NoAccess',
                title = hasPermissions ? i18next.t('glossary.opportunities') : `${WiseMetering.icon('lock')} ${i18next.t('glossary.opportunities').capitalize()}`;

            this.tabs.push({
                active: view === 'opportunities',
                href: `/${this.objectName()}/${model.id}/opportunities`,
                id: 'opportunities',
                name: title,
                view: WiseMetering.Views[viewName]
            });
        }

        if (model.type() === 'site') {
            const
                hasPermissions = WiseMetering.Permissions.hasPlanPermissions('objectives'),
                viewName = hasPermissions ? 'Objectives' : 'NoAccess',
                title = hasPermissions ? i18next.t('glossary.objectives') : `${WiseMetering.icon('lock')} ${i18next.t('glossary.objectives').capitalize()}`;

            this.tabs.push({
                active: view === 'objectives',
                href: `/${this.objectName()}/${model.id}/objectives`,
                id: 'objectives',
                name: title,
                view: WiseMetering.Views[viewName]
            });
        }

        if (model.isSite()) {
            this.tabs.push({
                active: view === 'reports',
                href: `/${this.objectName()}/${model.id}/reports`,
                id: 'reports',
                name: i18next.t('glossary.reports'),
                view: WiseMetering.Views.IndexReport
            });
        }

        if (model.isSite()) {
            this.tabs.push({
                active: view === 'indicators',
                href: `/${this.objectName()}/${model.id}/indicators`,
                id: 'indicators',
                name: i18next.t('glossary.indicators'),
                view: WiseMetering.Views.IndexIndicatorBySite
            });
        }

        if (model.isSite() && model.isActivated()) {
            this.tabs.push({
                active: view === 'scheduled_reports',
                href: `/${this.objectName()}/${model.id}/scheduled_reports`,
                id: 'scheduled-reports',
                name: i18next.t('glossary.scheduled_reports'),
                view: WiseMetering.Views.ScheduledReportsIndex,
                dropdownTab: true
            });
        }

        if (model.isSite() && model.isActivated()) {
            this.tabs.push({
                active: view === 'site_documents',
                href: `/${this.objectName()}/${model.id}/site_documents`,
                id: 'site-documents',
                name: i18next.t('common.documents'),
                view: WiseMetering.Views.IndexSiteDocuments,
                dropdownTab: true
            });
        }

        if (model.type() === 'site' && WiseMetering.Permissions.hasRolePermissions('zonePermissions', 'read')) {
            this.tabs.push({
                active: view === 'permissions',
                href: `/${this.objectName()}/${model.id}/permissions`,
                id: 'permissions',
                name: i18next.t('common.permissions'),
                view: WiseMetering.Views.ZonePermissions,
                dropdownTab: true
            });
        }
    },

    objectName: function() {
        return this.model.get('state') !== 'active' && this.model.isSite() ? 'sites' : 'zones';
    }
});
